import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { parentDashboardService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as actions from './actions';
import { of } from 'rxjs';


export function getCarerStudents(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_CARER_STUDENTS),
    mergeMap(({ payload }) => {
      return parentDashboardService.getCarerStudents(payload).pipe(
        map((res) =>
          actions.getCarerStudentsSuccess(res.responceObject.records)
        ),
        catchError((error) =>
          of({
            type: actionTypes.FETCH_CARER_STUDENTS_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getStudentList(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_STUDENT_LIST),
    mergeMap(({ payload }) => {
      return parentDashboardService.getStudentList(payload).pipe(
        map((res) => actions.getStudentListSuccess(res)),
        catchError((error) =>
          of({
            type: actionTypes.GET_STUDENT_LIST_FAIL,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getStudentNotes(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_STUDENT_NOTES),
    mergeMap(({ payload }) => {
      return parentDashboardService.getStudentNotes(payload).pipe(
        map((res) => actions.getStudentNotesSuccess(res)),
        catchError((error) =>
          of({
            type: actionTypes.FETCH_STUDENT_NOTES_FAIL,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function sendStudentNote(action$) {
  return action$.pipe(
    ofType(actionTypes.SEND_STUDENT_NOTE),
    mergeMap(({ payload }) => {
      return parentDashboardService.sendNotes(payload).pipe(
        map((res) =>
          actions.sendStudentNoteSuccess(res.responceObject.records)
        ),
        catchError((error) => {
          console.log(error);
        })
      );
    })
  );
}


export function getPlotCourses(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_PLOT_COURSES),
    mergeMap(({ payload }) => {
      return parentDashboardService.getPlotCourses(payload).pipe(
        map((res) => actions.getPlotCoursesSuccess(res.responceObject.records)),
        catchError((error) =>
          of({
            type: actionTypes.GET_PLOT_COURSES_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getPlotTask(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_PLOT_TASK),
    mergeMap(({ payload }) => {
      return parentDashboardService.getPlotTask(payload).pipe(
        map((res) => actions.getPlotTaskSuccess(res.responceObject.records)),
        catchError((error) =>
          of({
            type: actionTypes.GET_PLOT_TASK_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getStudentAcademicReposts(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_STUDENT_ACADEMIC_REPORT),
    mergeMap(({ payload }) => {
      return parentDashboardService.getStudentAcademicRepots(payload).pipe(
        map((res) =>
          actions.getStudentAcademicRepostsSuccess(res.responceObject.records)
        ),
        catchError((error) =>
          of({
            type: actionTypes.GGET_STUDENT_ACADEMIC_REPORT_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getStudentAbsenceSummary(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_STUDENT_ABSENCE_SUMMARY),
    mergeMap(({ payload }) => {
      return parentDashboardService.getStudentAbsenceSummary(payload).pipe(
        map((res) =>
          actions.getStudentAbsenceSummarySuccess(res.responceObject.records)
        ),
        catchError((error) =>
          of({
            type: actionTypes.GET_STUDENT_ABSENCE_SUMMARY_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getStudentLearningBehaviour(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR),
    mergeMap(({ payload }) => {
      return parentDashboardService.getLearningBehaviour(payload).pipe(
        map((res) =>
          actions.getStudentLearningBehaviourSuccess(res.responceObject.records)
        ),
        catchError((error) =>
          of({
            type: actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getStudentLearningGoals(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_STUDENT_LEARNING_GOALS),
    mergeMap(({ payload }) => {
      return parentDashboardService.getLearningGoals(payload).pipe(
        map((res) =>
          actions.getStudentLearningGoalsSuccess(res.responceObject.records)
        ),
        catchError((error) =>
          of({
            type: actionTypes.GET_STUDENT_LEARNING_GOALS_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getHomeRoomComments(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_HOME_ROOM_COMMENTS),
    mergeMap(({ payload }) => {
      return parentDashboardService.getHomeRoomComments(payload).pipe(
        map((res) =>
          actions.getHomeRoomCommentsSuccess(res.responceObject.records)
        ),
        catchError((error) =>
          of({
            type: actionTypes.GET_HOME_ROOM_COMMENTS_FAILED,
            payload: error,
            error: true,
          })
        )
      );
    })
  );
}

export function getStudentBehaviourByCourse(action$) {
  return action$.pipe(
    ofType(actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE),
    mergeMap(({ payload }) =>
      parentDashboardService.getLearningBehaviourByCourse(payload).pipe(
        map(res => {
          return res.returnData
        }),
        map((response) =>
          actions.getStudentLearningBehaviourByCourseSuccess(response)
        ),
        catchError((error) =>
          of({
            type: actionTypes.GET_STUDENT_LEARNING_BEHAVIOUR_BY_COURSE_FAILED,
            payload: error,
            error: true,
          })
        )
      )
    )
  );
}